export default {
  community: {
    title: "Join the Community",
    cards: [
      {
        title: "Community Forum",
        description:
          "Interact with other devs implementing innovative solutions with Auth0.",
        icon: "https://images.ctfassets.net/kbkgmx9upatd/6Z3jYghKHv8N27w1taHpQ4/1d7b03cc4f93adc534b8b3e2e898d3e7/icon-community.svg",
        url: "https://community.auth0.com/",
      },
      {
        title: "Zero Index Newsletter",
        description:
          "Get curated links to articles, videos, and developer productivity tips delivered to your inbox once a month.",
        icon: "https://images.ctfassets.net/kbkgmx9upatd/43gWV7niqMUrTyjbTdCRyS/cff354bfd65a7c1c0423976caa4b6de4/icon-newsletter.svg",
        url: "/newsletter",
      },
    ],
  },
};
